export default __webpack_public_path__ + "static/media/photo--lg--70.1afd6229.jpg";